class __fs_popup{

    selector;

    constructor(selector) {
        this.selector = FS(selector);
    }

    show(){
        this.hideAll();
        this.selector.addUniqueClass('popup--active');
        FS('body').addClass('popup-showing');
    }

    hideAll(){
        FS('.popup--active', 'all').removeClass('popup--active');
        FS('body').removeClass('popup-showing');
    }


}


function popup(selector = null){
    return new __fs_popup(selector);
}
document.addEventListener('DOMContentLoaded', function() {
    FS('.popup-close-btn', 'all').onClick(function (){
       popup().hideAll();
    });
});
document.addEventListener('DOMContentLoaded', function() {

    FS('.filials__bottom-more').onClick(function (){
        FS('.filials__bottom-more').hide();
        FS('.filials__bottom-scroll').show();
        FS('.filials__list').addClass('filials__list-listing');
    });




    const search = document.querySelector('#search-filial');




    FS('.filials__search input').onClick(function (){
        FS('body').addClass('filials-full');
    });
    FS('.filials__map-full-close').onClick(function (){
        FS('body').removeClass('filials-full');
    });


    const allLinks = document.querySelectorAll('.filials__list-name');
    const allAddress = document.querySelectorAll('.filials__list-address');
    const bottom = document.querySelector('.filials__bottom');
    search.onkeyup = function (event) {
        let count = 0;

        const regex = new RegExp(event.target.value.toLowerCase());
        allLinks.forEach(element => {
            if (regex.test(element.textContent.toLowerCase())) {
                element.parentNode.parentNode.style.display = '';
                count++;
            } else {
                element.parentNode.parentNode.style.display = 'none';
            }
        })
        allAddress.forEach(element => {
            if (regex.test(element.textContent.toLowerCase())) {
                element.parentNode.parentNode.style.display = '';
                count++;
            }
        })

        if(count > 4){
            bottom.style.display = '';
        }else{
            bottom.style.display = 'none';
        }

    }





});

FS('.filial-page__join').onClick(function (){
    popup('.schedule__popup').show();
});